import { LanguageService } from '../../shared/services/language.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ILogin } from '../../interfaces/ilogin';
import { IUser } from '../../interfaces/iuser';
import { environment } from '../../../environments/environment';
import { CryptoSharkService } from './crypto-shark.service';
import { HttpService } from './http.service';
import * as moment from 'moment-timezone'

@Injectable({
  providedIn: 'root',
})
/**
 * Servicio administrador de sesión de usuario
 */
export class UserService {
  private _login: ILogin = {}
  private _user: IUser = {}
  private _employee: any = {}

  public useEmployee: boolean = false;
  public mensaje: string = '';

  constructor(private httpService: HttpService, private router: Router, private cryptoService: CryptoSharkService, private languageService: LanguageService) { }

  /**
   * Guardar los datos del usuario
   * @param login Credenciales del usuario que inició sesión
   */
  signInCurrentUser(login: ILogin) {
    localStorage.setItem('ldt', JSON.stringify(login));
  }

  /**
   * Obtener datos de la sesión del usuario
   */
  get login() {
    return this._login
  }

  /**
   * Obtener datos del usuario
   */
  get user() {
    return this._user
  }

  /**
   * Obtener datos de sesión del usuario validUser()
   * @param returnUrl Url a la que regresará una vez que haya iniciado sesión
   */
  getCurrentUser(returnUrl: string): Promise<boolean> {
    return new Promise((resolve) => {
      this._login = JSON.parse(localStorage.getItem(`ldt`));

      if (!this._login?.isRegister) {
        this.router.navigate(['/login'], { queryParams: { returnUrl } });
        resolve(false);
      }
      environment.apiUrl = this._login.company.server;

      this.httpService.get(`api/login`).subscribe((response) => {

        this._login.company.key = response.key; //<-- ENCRYPT REQUESTS 
        this._login.company.dk = this.cryptoService.decrypt(response.datakey, response.key);//<-- DECRYPT RESPONSES
        if (this._login.company.serverMedia) this._login.company.serverMedia = this._login.company.serverMedia + `${response?.companyName}/assets/`;
        this._user.email = this.cryptoService.decrypt(response.email, this._login.company.key)
        this._user.name = this.cryptoService.decrypt(response.name, this._login.company.key)
        this._user.nickName = this.cryptoService.decrypt(response.nickname, this._login.company.key)
        this._user.roleName = response.roleName
        this._user.metrics_data = response.metrics;
        this._user.vacancy = response.vacancy;
        this._user.reports = response.reports;
        this._user.checkWithPhoto = response.checkWithPhoto;
        this._user.editChecks = response.editChecks;
        this._user.permissions = { ...response.permissions },
          this._user.permissionsEmp = { ...response.permissionsEmp }
        this._user.companyCountry = response.companyCountry;
        this._user.notCheckDigitalCredential = response.notCheckDigitalCredential;
        this._user.payrollsType = response.payrollsType;
        this._user.prepayrollsType = response.prepayrollsType;
        this._user.layoutsPayroll = response.layoutsPayroll;
        this._user.layoutsPrepayroll = response.layoutsPrepayroll;
        this._user.startWeek = response.startWeek || 1;
        this._user.doyMoment = response.doyMoment || 0;
        this._user.useUniformPackages = response.useUniformPackages || false;
        this._user.calendarType = response.calendarType || "SEMANAL";
        this._user.multiBusinessName = response.multiBusinessName || false;
        this._user.vacationsConfig = response.vacationsConfig || null;
        this._user.basicImport = response.basicImport || false;
        this._user.uniqueCSVpayroll = response.uniqueCSVpayroll || false;
        this._user.checkerBasicImport = response.checkerBasicImport;
        this._user.RegisterEmployees = response.registerEmployees || false;
        this._user.useSupervisorCode = response.vacationsConfig?.useSupervisorCode || false;
        this._user.credentialsConfig = response.credentialsConfig;
        this.languageService.setLanguageForUser(response.language ?? 'MX');
        this._user.employeeType = this._login?.employeeType;
        this._user.evaluationsConfig = response?.evaluationsConfig;
        this._user.checkedOffline = response.checkedOffline;
        moment.tz.setDefault(response?.timeZone || "America/Tijuana");
        this._user.branchFilters = response?.branchFilters;  // Muestra la columna de planta en tabla de empleados

        resolve(true)
      });
    })
  }

  /**
   * 
   * Obtener datos de sesión del empleado validUser()
   * @param returnUrl Url a la que regresará una vez que haya iniciado sesión
   */
  getEmployeeUser(returnUrl: string): Promise<boolean> {
    return new Promise((resolve) => {
      this._login = JSON.parse(localStorage.getItem(`ldt`));

      environment.apiUrl = this._login.company.server;
      this._user.employeeType = this._login?.employeeType;

      this.httpService.get(`api/login`).subscribe((response) => {
        this._login.company.key = response.key; //<-- ENCRYPT REQUESTS 
        this._login.company.dk = this.cryptoService.decrypt(response.datakey, response.key);//<-- DECRYPT RESPONSES
        if (this._login.company.serverMedia) this._login.company.serverMedia = `/assets/`;

        this._user.email = (response?.employee?.email) ? this.cryptoService.decrypt(response?.employee?.email, this._login.company.dk) : '';
        this._user.name = (response?.employee?.name) ? this.cryptoService.decrypt(response?.employee?.name, this._login.company.dk) : '';
        this._user.nickName = (response?.employee?.number) ? this.cryptoService.decrypt(response?.employee?.number, this._login.company.dk) : '';
        this._user.roleName = "employee";
        this._user.supervisor = response?.employee?.supervisor || false;
        this._user.director = response?.employee?.director || false;
        this._user.employeeId = response?.employee?._id;
        this._user.evaluationsConfig = response?.evaluationsConfig;
        this._user.startWeek = response.startWeek || 1;
        this._user.doyMoment = response.doyMoment || 0;
        this._user.checkWithPhoto = response.checkWithPhoto;
        this._user.editChecks = response.editChecks;
        this._user.permissionsEmp = { ...response.permissionsEmp }
        
        // Logic for multiple roles
        this._user.roles = response?.employee?.roles || [];
        if (this._user.roles.length > 0) {
          const defaultRoleId = response?.employee?.defaultRoleId;

          let activeRole = this._user.roles[0]; // Default to first role

          if (defaultRoleId) {
             const foundDefault = this._user.roles.find(r => r._id === defaultRoleId);
             if (foundDefault) activeRole = foundDefault;
          } 



          // Override permissions with the activerole's permissions
          if (activeRole.permissions) {
            this._user.permissionsEmp = { ...activeRole.permissions };
          }
          
          
          // Optionally store the active role name for display
          this._user.roleName = activeRole.name || "employee"; 
          this._user.activeRoleId = activeRole._id;
        }
        this.languageService.setLanguageForUser('MX');
        moment.tz.setDefault("America/Tijuana");
        this._user.branchFilters = response?.branchFilters; // Muestra la columna de planta en tabla de empleados

        resolve(true)
      });
    })
  }

  /**
   * Cerrar sesión
   * Borrar los datos de sesión del usuario
   */
  signOutCurrentUser() {
    // environment.apiUrl = 'http://10.10.2.34:9000/'
    environment.apiUrl = environment.urlAdmin;
    localStorage.removeItem('ldt')
    this.router.navigate(['/login'])
  }
}
